import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { PerformanceRatingsEnum } from '@features/enums/performance-ratings-enum';
import { SolidStarIconComponent } from '@shared/icons/solid-star-icon.component';
import { RatingWithTrim } from '@shared/models/fans/rating-with-trim';

@Component({
  selector: 'app-rate-with-trim',
  standalone: true,
  imports: [NgClass, SolidStarIconComponent],
  templateUrl: './rate-with-trim.component.html'
})
export class RateWithTrimComponent {

  @Input() rating: RatingWithTrim | undefined;
  @Output() ratingChange = new EventEmitter<RatingWithTrim>();

  protected readonly PerformanceRatingsEnum = PerformanceRatingsEnum;

  updateRating(value: PerformanceRatingsEnum) {
    this.ratingChange.emit({
      rating: value,
      trim: this.rating?.trim,
      comment: this.rating?.comment
    });
  }

  updateTrim(trim: number) {
    if (!this.rating) {
      return;
    }

    this.ratingChange.emit({
      ...this.rating,
      trim
    });
  }

}
